import { DatePickerProps } from 'antd';
import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DATE_FORMAT } from '../../../constants';
import FormField from '../Field';
import * as Styled from './DatePicker.styles';

interface PickerProps extends Omit<DatePickerProps, 'format'> {
  format?: string;
}

const DatePicker = ({ size = 'small', format = DATE_FORMAT, onChange, ...rest }: PickerProps) => {
  const { t } = useTranslation();
  const [value, setValue] = useState<string | null>();
  const [invalidFormat, setInvalidFormat] = useState<boolean>(false);

  return (
    <>
      <Styled.DatePicker
        {...rest}
        format={format}
        onBlur={(e) => {
          if (value) {
            const isValidDate = moment(value, format, true).isValid();
            if (isValidDate) {
              onChange?.(moment(value, format), value);
            } else {
              setInvalidFormat(true);
            }

            setValue(null);
          }
          rest.onBlur?.(e);
        }}
        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
          if (e.target instanceof HTMLInputElement) {
            const index = e.target.selectionStart;
            const currentValue = e.target.value;
            if (index) {
              setValue(currentValue.slice(0, index) + e.key + currentValue.slice(index));
            }
          }
        }}
        onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
          setInvalidFormat(false);
          rest.onFocus?.(e);
        }}
        onChange={onChange}
      />
      {invalidFormat && (
        <Styled.InvalidFormatMessage>{t('error.wrongDateFormat')}</Styled.InvalidFormatMessage>
      )}
    </>
  );
};

const FormDatePicker = FormField<string>(DatePicker);

export default FormDatePicker;
